<template>
  <div class="sui-table">
    <div class="panel panel-info" v-if="filterGen.length > 0 || showActionBar">
      <div class="panel-heading">
        <div class="form-inline">
          <dropdown ref="dropdown" v-for="(d, k) in filterGen" :key="`dd-${k}`"
                    class="form-group">
            <btn type="primary"
                 :disabled="filterDisabled"
                 class="dropdown-toggle">
              {{ d.title }} <span class="caret"></span>
            </btn>
            <template slot="dropdown">
              <li v-for="(f, i) in d.list"
                  :class="{'divider': f.name == null}"
                  :key="`item-${k}-${i}`">

                <a role="button"
                   v-if="f.name != null"
                   @click="data.filter = f.filter">
                  {{ f.name }}
                </a>
              </li>
            </template>
          </dropdown>
          <slot name="actions"></slot>
        </div>
      </div>
    </div>
    <div class="row" v-show="showFilter">
      <div class="col-xs-12">
        <sui-filter-input v-model="data"
                          :disabled="filterDisabled"
                          :variables="filterVariables"
                          :list="list">
        </sui-filter-input>
      </div>
    </div>
    <tabs v-model="tab">
      <tab title="Liste">
        <table class="table table-responsive">
          <thead>
            <tr class="info">
              <th v-for="(c, k) in columns"
                  class="botable-column-title"
                  unselectable="on"
                  :class="{ 'text-center': k > 0 || (k === columns.length && actions.length === 0) }"
                  :key="k"
                  @click="setSort(c.field)">
                <span v-if="c.html" v-html="c.html"></span>
                <span v-else>
                  {{ c.name }}
                </span>
                <small v-if="sort === c.field"
                       class="glyphicon"
                       :class="sortGlyph()">
                </small>
              </th>
              <th v-if="actions.length > 0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="u in page" :key="u[keyfield]"
                :class="{ active: isSelected(u) }">
              <td v-for="(c, k) in columns" :key="k"
                  :class="{ 'text-center': k !== 0 }"
                  v-html="u[c.field]">
              </td>
              <td v-if="actions.length > 0">
                <span v-for="(a, k) in actions" :key="`${u[keyfield]}-${k}`"
                      v-if="a.show == null || a.show(u)" >
                  <a @click="trigger(a.event, u)">{{ a.name }}</a>&nbsp;
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination v-if="pageCount > 1" v-model="index" :total-page="pageCount"/>
      </tab>
      <tab title="Caractéristiques" v-if="showCaracteristicsTab">
        <sui-results-caracteristics
          :caracteristics="caracteristics"
          :title="title"
          subtitle="">
          <p>Aucune caractéristique pour cette liste.</p>
        </sui-results-caracteristics>
      </tab>
    </tabs>
  </div>
</template>

<script>
import rtti from '@/sui/tools/rtti'
import ice from '@/sui/tools/ice'
import assert from '@/sui/tools/assert'
import suiFilterInput from '@/sui/components/filterInput'
import suiResultsCaracteristics from '@/sui/components/results/caracteristics'

import moment from 'moment'

export default {
  name: 'sui-table',
  props: {
    columns: Array,
    actions: Array,
    list: Array,
    title: String,
    initialSort: {
      type: Object,
      default: () => { return { field: '', ascend: true } }
    },
    filterGen: {
      type: Array,
      default: () => []
    },

    showActionBar: {
      type: Boolean,
      default: false
    },

    filterVariables: {
      type: Array,
      default: () => []
    },
    filterDisabled: {
      type: Boolean,
      default: false
    },
    keyfield: String,
    selected: {
      field: String,
      value: String
    },
    filter: String,
    showFilter: {
      type: Boolean,
      default: true
    },
    formatter: {
      type: Object
    },
    caracteristicsBuilder: {
      type: Function
    }
  },

  data () {
    return {
      index: 1,
      countPerPage: 15,
      sort: this.initialSort.field,
      ascend: this.initialSort.ascend,
      data: { filter: '', list: [] },
      tab: 0
    }
  },

  watch: {
    initialSort: {
      handler (val) {
        this.sort = val.field
        this.ascend = val.ascend
      },
      deep: true
    },

    pageCount: function (v) {
      this.index = 1
    },

    filter: function (f) {
      this.data.filter = f
    },

    list: function (v) {
      this.data.list = v
    }
  },

  computed: {
    sortedData: function () {
      const { sort, ascend } = this
      if (sort === '') {
        return this.data.list
      }

      function compare (a, b) {
        const va = a[sort]
        const vb = b[sort]
        const sign = (ascend ? 1 : -1)

        if (vb == null) {
          return -sign
        }

        if (va == null) {
          return sign
        }

        if (va < vb) {
          return -sign
        }

        if (va > vb) {
          return sign
        }
        return 0
      }

      return this.data.list.slice().sort(compare)
    },

    formattedList: function () {
      const result = []
      for (let i in this.sortedData) {
        const s = this.sortedData[i]
        const out = {
          src: s
        }
        const keys = Object.keys(s)
        for (let j = 0; j !== keys.length; ++j) {
          const k = keys[j]
          assert.notNull(s[k], `Invalid value for key ${k}`)
          out[k] = this.formatValue(k, s[k])
        }

        result.push(out)
      }

      return ice.freeze(result)
    },

    page: function () {
      if (this.formattedList == null) {
        return []
      }

      const { index, countPerPage } = this
      const start = (index - 1) * countPerPage
      return this.formattedList.slice(start, start + countPerPage)
    },

    pageCount: function () {
      if (this.formattedList == null) {
        return 0
      }
      return Math.ceil(this.formattedList.length / this.countPerPage)
    },

    showCaracteristicsTab: function () {
      return this.caracteristicsBuilder != null
    },

    caracteristics: function () {
      if (!this.showCaracteristicsTab || this.tab !== 1) {
        return null
      }

      return this.caracteristicsBuilder(this.data.list)
    }
  },

  methods: {
    isSelected: function (u) {
      if (this.selected == null) {
        return false
      }
      return u[this.selected.field] === this.selected.value
    },

    trigger: function (event, data) {
      this.$emit(event, data)
    },

    setSort: function (sort) {
      if (this.sort === sort) {
        this.ascend = !this.ascend
      }
      this.sort = sort
    },

    sortGlyph: function () {
      if (this.ascend) {
        return 'glyphicon-sort-by-attributes'
      }

      return 'glyphicon-sort-by-attributes-alt'
    },

    formatValue: function (key, value) {
      if (this.formatter != null) {
        const f = this.formatter[key]
        if (f != null) {
          return f(value)
        }
      }

      switch (typeof value) {
        case 'boolean':
          if (value) { return 'Oui' }
          return 'Non'
        case 'object':
          if (rtti.isArray(value)) {
            return value.join(', ')
          } else if (moment.isMoment(value)) {
            return value.format('DD/MM/YYYY HH:mm')
          } else if (value.format != null) {
            return value.format()
          } else {
            return value
          }
        default:
          return value
      }
    }
  },

  components: {
    suiFilterInput,
    suiResultsCaracteristics
  }
}
</script>

<style scoped lang="less">
@import '~variables';

a:hover {
    cursor: pointer;
}

table {
  font-size: 90%;
}

.botable-column-title {
    cursor: pointer;
    -khtml-user-select: none;
    -ms-user-select:none;
    -moz-user-select:none;
    -webkit-user-select:none;
}
</style>
